<template>
	<v-navigation-drawer
		v-model="show"
		:width="clientWidth"		
		fixed
		right
		temporary	 	
		@input="handleDrawerToggled">

		<template v-if="loading">
			<v-layout fill-height align-center justify-center ma-0>
				<v-progress-circular :indeterminate="loading"></v-progress-circular>
			</v-layout>
		</template>
		<template v-else-if="content && contentKeys">
			<v-card class="preview-panel">
				<v-toolbar color="grey lighten-2" flat>
				    <v-toolbar-title class="grey--text text--darken-4" v-html="contentTitle" @click="handleOpenContent"></v-toolbar-title>
				    <v-spacer></v-spacer>
				    <v-btn icon light>
				        <v-icon color="grey darken-2" @click.stop="handleClose">close</v-icon>
				    </v-btn>
				</v-toolbar>
				<v-subheader class="pl-4 border-bottom-dashed">{{ contentUrl }}</v-subheader>
				<v-subheader class="pl-4"><span v-html="contentCreator"></span><v-spacer></v-spacer><span v-html="contentPublishedOn"></span></v-subheader>

				<v-flex class="content-body" px-4 pb-5 v-if="contentKeys.contentType != 'COMMENT'">
					<template v-for="block in content.blocks">
						<template v-if="block.blockType == 'TEXT'">
							<p class="py-3 mb-0" v-if="block.blockType == 'TEXT'" v-html="block.data.contentText.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
						</template>
						<template v-else-if="block.blockType == 'IMAGE' || block.blockType == 'FINISH-LOOK'">
							<v-card v-for="(image, n) in block.data" :key="image.id" flat tile class="py-2">
								<v-img contain :src="`https://www.jeban.com${image.imageSrc.replace('http://s.jeban.com', '').replace('http://www.jeban.com', '').replace('https://www.jeban.com', '')}`" max-height="150"></v-img>
							</v-card>
						</template>
						<template v-else-if="block.blockType == 'HAUL' || block.blockType == 'STEP'">
							<v-card flat tile class="py-2">
								<v-img contain :src="`https://www.jeban.com${block.data.image.imageSrc}`" max-height="150"></v-img>
							</v-card>
						</template>
						<template v-else-if="block.blockType == 'VIDEO'">
							<div class="py-2">
								<iframe v-if="block.data.videoType == 'YOUTUBE'" width="320" height="180" :src="`https://www.youtube.com/embed/${block.data.videoId}`" frameborder="0" allowfullscreen></iframe>
							</div>
						</template>
						<template v-else-if="block.blockType == 'BEFORE-AFTER'">
							<div class="mb-3 before-after-block">
								<v-subheader class="pl-0">BEFORE/AFTER</v-subheader>
								<v-card flat tile class="pb-2">
									<v-img contain :src="`https://www.jeban.com${block.data.imageBefore.imageSrc}`" max-height="150"></v-img>
								</v-card>
								<v-card flat tile class="pb-3">
									<v-img contain :src="`https://www.jeban.com${block.data.imageAfter.imageSrc}`" max-height="150"></v-img>
								</v-card>
							</div>
						</template>
						<template v-else-if="block.blockType == 'PRODUCT'">
							<div class="mb-3 pb-3 before-after-block">
								<v-subheader class="pl-0">RELATED ITEMS</v-subheader>
								<v-avatar v-for="(product, n) in block.data" :key="n" size="62" class="mr-2 elevation-3">
									<v-img contain :src="product.imageUrl" aspect-ratio="1" max-height="42"></v-img>
								</v-avatar>
							</div>
						</template>
						<template v-else-if="block.blockType == 'REVIEW'">
							<div class="mb-3 pb-3 before-after-block">
								<v-subheader class="pl-0">REVIEW</v-subheader>
								<v-avatar size="62" class="mr-2 elevation-3">
									<v-img contain :src="block.data.product.imageUrl" aspect-ratio="1" max-height="42"></v-img>
								</v-avatar>
							</div>
						</template>
					</template>
				</v-flex>
				<v-flex class="content-body" px-4 pb-5  v-else>

					<v-flex xs12>
					    <v-card class="root-content">
					        <v-layout>
					            <v-flex xs4>
					                <v-img :src="content.rootContent.content.coverUrl" height="125px" aspect-ratio="1"></v-img>
					            </v-flex>
					            <v-flex xs8 pa-3>
					                <div class="subtitle-1" v-html="contentTitle" @click="handleOpenContent"></div>
					            </v-flex>
					        </v-layout>
					    </v-card>
					</v-flex>

					<v-timeline dense clipped align-top>
					    <v-timeline-item class="mt-3">
					        <template v-slot:icon>
					            <v-avatar>
					                <img :src="content.user.avatar">
					            </v-avatar>
					        </template>
					        <v-card class="elevation-5">
					            <v-card-text>
									<template v-for="block in content.blocks">
										<template v-if="block.blockType == 'TEXT'">
											<p class="py-3 mb-0" v-if="block.blockType == 'TEXT'" v-html="block.data.contentText.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
										</template>
										<template v-else-if="block.blockType == 'IMAGE'">
											<v-img v-for="(image, n) in block.data" :key="image.id" contain :src="`https://www.jeban.com${image.imageSrc.replace('http://s.jeban.com', '').replace('http://www.jeban.com', '').replace('https://www.jeban.com', '')}`" max-height="150"></v-img>
										</template>
										<template v-else-if="block.blockType == 'STICKER'">
											<v-img contain :src="block.data.sticker.stickerUrl" max-height="100"></v-img>
										</template>
									</template>
					            </v-card-text>
					        </v-card>
							<v-subheader class="pl-0"><span v-html="content.user.username"></span><v-spacer></v-spacer><span v-html="content.publishedOn"></span></v-subheader>
					    </v-timeline-item>
					</v-timeline>

				</v-flex>

				<v-card-actions v-if="actionButtons" class="px-4">
					<template v-for="(action, index) in buttonsOnLeft">
						<v-btn v-bind="action.options" :text="action.options.text" @click="handleActionClick(action)" class="mt-12">{{ action.text }}</v-btn>
					</template>
					<v-spacer></v-spacer>
					<template v-for="(action, index) in buttonsOnRight">
						<v-btn v-bind="action.options" :text="action.options.text" @click="handleActionClick(action)" class="mt-12">{{ action.text }}</v-btn>
					</template>					
				</v-card-actions>
			</v-card>
		</template>
	</v-navigation-drawer>	
</template>

<script>
	import * as config from '@/config'

	export default {
		props: {
			contentKeys: {
				type: [Array, Object],
				default: null
			},
			actionButtons: {
				type: Array,
				default: null
			}
		},
		data () {
			return {
				show: false,
				loading: false,
				content: null
			}
		},
		computed: {
			clientWidth () 
			{
				return (window.innerWidth > 640) ? 640 : window.innerWidth
			},
			contentTitle () 
			{
				if (!this.content) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return (typeof this.content.rootContent.content !== 'undefined') ? this.content.rootContent.content.title : ''
				} else {
					return (typeof this.content.title !== 'undefined') ? this.content.title : ''
				}
			},
			contentCreator () 
			{
				if (!this.content) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return (typeof this.content.rootContent.content !== 'undefined') ? this.content.rootContent.content.user.username : ''
				} else {
					return (typeof this.content.user.username !== 'undefined') ? this.content.user.username : ''
				}
			},
			contentPublishedOn () 
			{
				if (!this.content) {
					return null
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return (typeof this.content.rootContent.content !== 'undefined') ? this.content.rootContent.content.publishedOn : null
				} else {
					return (typeof this.content.publishedOn !== 'undefined') ? this.content.publishedOn : null
				}
			},
			contentUrl () 
			{
				if (!this.contentKeys) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return `https://www.jeban.com/${this.content.rootContent.contentType.toLowerCase()}/${this.content.rootContent.contentId}/comment/${this.content.id}`
				} else if (this.contentKeys.contentType.toLowerCase() == 'check') {
					return `https://www.jeban.com/beautycheck/${this.contentKeys.contentId}`
				} else {
					return `https://www.jeban.com/${this.contentKeys.contentType.toLowerCase()}/${this.contentKeys.contentId}`
				}				
			},
			contentApi ()
			{
				if (!this.contentKeys) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'check') {
					return `${config.BASE_URL}/beautycheck/${this.contentKeys.contentId}`
				} else {
					return `${config.BASE_URL}/${this.contentKeys.contentType.toLowerCase()}/${this.contentKeys.contentId}`
				}				
			},
			buttonsOnLeft () 
			{
				return this.actionButtons.filter(a => ((typeof a.align === 'undefined') || (a.align != 'right')))
			},
			buttonsOnRight ()
			{
				return this.actionButtons.filter(a => ((typeof a.align !== 'undefined') && (a.align == 'right')))
			}
		},
		methods: {
			handleOpenContent ()
			{
				window.open(this.contentUrl, '_blank')
			},
			handleClose () 
			{
				this.$emit('close')
			},
			handleActionClick (action)
			{
				this.$emit(action.eventName, this.contentKeys)
			},
			handleDrawerToggled (value)
			{
				if (!value) this.$emit('close')
			},
		},
		mounted () {
	        window.addEventListener('keyup', e => {
	            // If  ESC key was pressed...
	            if (e.keyCode === 27) {
	                // try close your dialog
	                this.handleClose()
	            }
	        })
		},
		watch: {
			contentKeys (value) 
			{
				this.show = (value) ? true : false
				if (value) {
					this.loading = true
					axios.get(this.contentApi)
						.then(response => {
							this.content = response.data.data
							this.loading = false
						})
						.catch(error => {
							console.log(error)
							this.loading = false
						})
				}
			}
		}
	}
</script>

<style lang="scss">
	.v-toolbar__title {
		cursor: pointer;
		user-select: none;
	}
	.preview-panel {
		min-height: 100vh;
		display: flex;
		flex-flow: column;

		.content-body {
			flex: 1;

			.v-image__image--contain {
				background-position: left center !important;
			}
			.v-avatar {
				.v-image__image--contain {
					background-position: center center !important;
				}
			}

			.before-after-block {
				border-top: 1px dashed #ccc;
				border-bottom: 1px dashed #ccc;
			}
		}

		.root-content {
			opacity: .5;
		}
	}

	.border-bottom-dashed {
		border-bottom: 1px dashed #ccc;
	}
</style>